<template>
  <v-dialog v-model="dialog" width="300" scrollable>
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        depressed
        class="primary"
        tile
        color="white"
        :class="$root.isMobile ? 'mt-3' : 'ml-3'"
        :width="$root.isMobile ? '100%' : '140px'"
      >
        Dispose Job
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Dispose Job </v-card-title>
      <v-card-text class="pb-0 pt-3">
        <v-form v-model="isValid" ref="form">
          <v-autocomplete
            v-model="dispose"
            item-text="name"
            item-value="id"
            dense
            :rules="rules"
            :items="items"
            outlined
            label="Select Desposition"
          ></v-autocomplete>
          <v-select
            v-if="reasonField && isCancelled"
            v-model="reason"
            item-text="name"
            item-value="value"
            dense
            :rules="rules"
            :items="reasonField.options"
            outlined
            :label="reasonField.name"
          ></v-select>
          <v-select
            v-if="isComplete"
              v-model="completeStatus"
              :items="completeOptions"
              item-text="name"
              item-value="value"
              dense
              :rules="rules"
              outlined
              label="Completion Status"
            
            ></v-select>
          <date-picker
            outlined
            :max="max"
            :rules="rules"
            label="Desposition Date"
            v-model="disposition_date"
          ></date-picker>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red" @click="dialog = false">Cancel</v-btn>
        <v-btn text color="green" @click="submit()">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {
  getDate,
  getDateOnly,
  getNormalDateTime,
} from "../../../assets/js/common";
import customerModal from "../../../assets/js/customer.modal";
import { customers, functions } from "../../../assets/js/firebase";
import { FIELD } from "../../../assets/js/rules";
import DatePicker from "../../DatePicker.vue";
export default {
  components: { DatePicker },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
      isValid: false,
      rules: FIELD,
      max: getDateOnly(),
      disposition_date: getDate(),
      dispose: customerModal.DISPOSITION_COMPLETE,
      reason: "",
      completeStatus: 'completed_paid',
    };
  },
  computed: {
    isCancelled() {
      return this.dispose === customerModal.DISPOSITION_CANCEL;
    },
    isComplete() {
    return this.dispose === customerModal.DISPOSITION_COMPLETE;
    },
    global() {
      return this.$store.getters.globalFields;
    },
    reasonField() {
      return [...this.global].find(
        (i) => i.id === customerModal.REASON_FOR_CANCELLATION
      );
    },
    items() {
      return this.$store.getters.dispositions;
    },
    completeOptions() {
      return [
      { name: 'Completed and paid', value: 'completed_paid' },
      { name: 'Not paid', value: 'completed_not_paid' },
      ];
    },
  },
  methods: {
    async submit() {
    const vm = this;
    vm.$refs.form.validate();
    if (!vm.isValid) return;
    try {
      if (vm.dispose == customerModal.DISPOSITION_COMPLETE) {
        vm.dialog = false;
        vm.$emit("onComplete", getNormalDateTime(vm.disposition_date));
        
        // Call the Firebase function when disposition is COMPLETE
        try {
          vm.$loader.show();
          await customers.doc(vm.item.id).update({
            // status: 7,
            // disposition: vm.dispose,
            // disposition_date: getNormalDateTime(vm.disposition_date),
            'fields.completion_status': vm.completeStatus,
            updated_at: getDate(),
          });
          const stockDecreaseFunction = functions.httpsCallable("stockDecrease");
          await stockDecreaseFunction({ itemId: vm.item.id });
          vm.$loader.hide();
        } catch (error) {
          console.log('Error in SelectDispose', error.message)
          vm.$loader.hide();
        }
        // console.log("Stock Decrease Response:", data);

      } else {
        vm.$loader.show();
        const latestData =await customers.doc(vm.item.id).get();
          console.log('latestData:',latestData.data())
          console.log('vm.reason:',vm.reason)
        await customers.doc(vm.item.id).update({
          status: 7,
          disposition: vm.dispose,
          disposition_date: getNormalDateTime(vm.disposition_date),
          [`fields.${customerModal.REASON_FOR_CANCELLATION}`]: vm.reason,
          updated_at: getDate(),
        });
        vm.$loader.hide();
        vm.dialog = false;
      }
    } catch (error) {
      vm.$alert.show(error.message);
      vm.$loader.hide();
    }
  },
},
}
</script>

<style></style>
